module.exports = __webpack_public_path__ + "static/img/3141.2dcac92.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/map/3141.png
// module id = WXOP
// module chunks = 1